<template>
  <div class="view-container">
    <el-tabs v-model="activeTab" type="card" class="order-tab-container">
      <el-tab-pane label="订单信息" name="orderInfo">
        <order-tab :order-detail="orderDetails" @update:orderRepaymentList="updateOrderRepaymentList"
                   :content-height="contentHeight()"/>
      </el-tab-pane>
      <el-tab-pane label="客户资料" name="orderCustomer">
        <customer-tab :order-detail="orderDetails"/>
      </el-tab-pane>
      <el-tab-pane label="签约信息" name="carInfo">
        <sign-tab :order-detail="orderDetails"/>
      </el-tab-pane>
      <el-tab-pane label="抵押信息" name="carEvaluation">
        <order-tab-content>
          <el-empty v-if="!orderDetails.hockMaterialList" description="暂无数据"/>
          <hock-tab v-else :hock-material-list="orderDetails.hockMaterialList"/>
        </order-tab-content>
      </el-tab-pane>
      <el-tab-pane label="审批记录" name="flowRecord">
        <order-flow-record ref="recordView" :order-no="orderNo" :height="contentHeight()"/>
      </el-tab-pane>
    </el-tabs>
    <div v-show="showOperation" class="fixed-action-buttons">
      <order-operation ref="action" :is-approval="isApproval && approvalctl" :order-detail="orderDetails"
                       @operation:complete="dealOperation" @operation:hidden="hiddenOperation"/>
    </div>
  </div>
</template>

<script>
import {hasPer} from "@/utils/common";
import OrderFlowRecord from "@/views/approval/task/orderFlowRecord.vue";
import {getOrderDetail} from "@/api/order/order";
import CustomerTab from "@/views/order/info/tab/customerTab.vue";
import OrderTab from "@/views/order/info/tab/orderTab.vue";
import SignTab from "@/views/order/info/tab/signTab.vue";
import HockTab from "@/views/order/info/tab/hockTab.vue";
import OrderOperation from "@/views/order/info/componet/orderOperation.vue";
import OrderTabContent from "@/views/order/info/tab/orderTabContent.vue";

export default {
  name: "orderView",
  components: {
    OrderTabContent,
    OrderOperation,
    HockTab,
    SignTab,
    OrderTab,
    CustomerTab,
    OrderFlowRecord
  },
  data() {
    return {
      showOperation: true,
      activeTab: 'orderInfo',
      approvalctl: true,
      orderDetails: {
        // order: {},
        orderBankList: [],
        // orderCar: {},
        // orderCarAssessment: {},
        // orderCompact: {},
        compactMaterialList: [],
        // orderCustomer: {},
        // orderWork: {},
        customerMaterialList: [],
        orderContactList: [],
        // orderFinance: {},
        orderGuaranteeList: [],
        // orderReady: {},
        orderRepaymentList: [],
        hockMaterialList: [],
        cityRegionList: []
      },
      dialogVisible: false
    };
  },
  computed: {
    orderNo() {
      return this.$route.params.orderNo;
    },
    isApproval() {
      return this.$route.params.isApproval || this.$route.params.isApproval === 'true';
    }
  },
  mounted() {
    this.hasOperation()
  },
  created() {
    this.getData();
  },
  methods: {
    hasPer,
    getData() {
      getOrderDetail({orderNo: this.orderNo}).then(res => {
        this.orderDetails = res
      })
    },
    closeView() {
      this.$eventBus.$emit('close-tab', this.isApproval ? '订单审批' : '订单查看');
    },
    updateOrderRepaymentList(val) {
      this.orderDetails.orderRepaymentList = val
    },
    reloadData() {
      //对订单进行了操作，需要重新加载数据
      this.getData()
      this.$forceUpdate()
    },
    updateContainerHeight(dynamicHeight) {
      document.documentElement.style.setProperty('--order-container-height', `calc(100vh - ${dynamicHeight}px)`);
      document.documentElement.style.setProperty('--order-content-height', `calc(100vh - ${dynamicHeight}px - 135px)`);
    },
    hiddenOperation() {
      this.showOperation = false
      this.updateContainerHeight(this.dynamicHeight());
    },
    hasOperation() {
      this.showOperation = true
      this.updateContainerHeight(this.dynamicHeight());
    },
    dynamicHeight() {
      return this.showOperation ? 200 : 140
    },
    contentHeight() {
      return Math.round(window.innerHeight) - this.dynamicHeight() - 135
    },
    dealOperation(action) {
      if (action === 'audit') {
        this.approvalctl = false
        this.closeView()
      } else {
        this.reloadData()
      }
    }
  }
};
</script>
<style>
:root {
  --order-container-height: calc(100vh);
  --order-content-height: calc(100vh);
}

.order-container {
  height: 100%;
  padding: 10px;
  border-radius: 4px;
}

.order-tab-container {
  height: 100%;
  border: 1px solid #dcdcdc;
  border-radius: 4px;

  :deep(.el-tabs__content) {
    height: var(--order-content-height) !important;
    padding: 5px 10px 0 10px;
    border-top: 1px solid #dcdcdc;
    overflow-y: auto;
  }
}

.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>
<style scoped>
.view-container {
  height: var(--order-container-height) !important;
  border-radius: 4px;
  padding-bottom: 20px;
  overflow-y: hidden;
}

:deep(.el-tabs__header) {
  margin: 0;
}

:deep(.el-tabs__content) {
  /*height: calc(var(--order-container-height) - 55px);*/
  height: auto;
  padding: 5px 10px 0 10px;
  border-top: 1px solid #dcdcdc;
  overflow-y: hidden;
}

.fixed-action-buttons {
  width: 100%;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding-right: 100px;
  padding-bottom: 20px;
}
</style>
